import styled from 'styled-components';
import ReactSVG from 'react-svg';
import { Link as LinkRouter } from 'react-router-dom';

import ExLinkSVG from './icons/ex-link.svg';
import MailSVG from './icons/mail.svg';
import TelegramSVG from './icons/telegram.svg';
import GithubSVG from './icons/github.svg';

export const Wrap = styled.div`
  max-width: 780px;
  padding: 0;
  margin: 200px auto 0;

  h1 {
    font-size: 40px;
    margin-bottom: 10px;

    .ufo-letter {
      font-size: 26px;
    }
  }
  h2 {
    font-size: 20px;
    margin-bottom: 30px;

    .flags {
      position: relative;
      top: 3px;
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 50px;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  width: 120px;
`;

export const Item = styled.div`
  display: flex;
  margin-bottom: 10px;

  a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.lightBlue};
    text-decoration: none;
  }
`;

export const ExLink = styled(ReactSVG).attrs({
  src: ExLinkSVG,
})`
  margin-left: 7px;

  svg {
    fill: #fff;
    width: 15px;
    height: 15px;
  }
`;

const icon = `
  margin-right: 10px; 
  svg {
    fill: #fff;
  }
`;

export const Telegram = styled(ReactSVG).attrs({
  src: TelegramSVG,
})`
  ${icon};
`;
export const Mail = styled(ReactSVG).attrs({
  src: MailSVG,
})`
  ${icon};
`;
export const Github = styled(ReactSVG).attrs({
  src: GithubSVG,
})`
  ${icon};
`;

export const Link = styled.a`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const LinkItem = styled(LinkRouter)`
  margin-top: 20px;
  font-family: 'Chemistry', sans-serif;
  font-size: 30px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};

  display: flex;
  align-items: center;

  span {
    display: inline-block;
    margin-left: 10px;
    font-size: 25px;
    transition: ${({ theme }) => theme.transition.button};
  }
  &:hover {
    span {
      transform: translateX(2px);
    }
  }
`;
